import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function PurchaseRequest() {
    
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [userData, setUserData] = useState([]);
    const [inventoryItems, setInventoryItems] = useState([]);
    const [editId, setEditId] = useState(null);
    const [requestItems, setRequestItems] = useState([{
        item: "", quantity: ""
    }]);
    const [formData, setFormData] = useState({
        request_no: "",
        requested_by: "",
        request_date: "",
        purpose: "",
        status: "PENDING"
    });
    useEffect(() => {
        getPurchaseRequests();
        getInventoryItems();
    }, []);
    const getPurchaseRequests = () => {
        setLoading(true);
        axios.get(baseUrl + "purchase-request/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
   useEffect(() => {
        try {
            axios.get(`${baseUrl}user-profile/`)
                .then(function (response) {
                    setUserData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const getInventoryItems = () => {
        axios.get(baseUrl + "inventory-item/")
            .then((res) => {
                setInventoryItems(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const handleItemChange = (index, e) => {
        const values = [...requestItems];
        values[index][e.target.name] = e.target.value;
        setRequestItems(values);
    };
    const addRow = () => {
        setRequestItems([
            ...requestItems,
            {
                item: "",
                quantity: ""
            }
        ]);
    };
    const removeRow = (index) => {
        const values = [...requestItems];
        values.splice(index, 1);
        setRequestItems(values);
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            request_no: "",
            requested_by: "",
            request_date: "",
            purpose: "",
            status: "PENDING"
        });
        setRequestItems([{
            item: "", quantity: ""
        }]);
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            request_no: row.request_no,
            requested_by: row.requested_by.id,
            request_date: row.request_date,
            purpose: row.purpose,
            status: row.status
        });
        if (row.items) {
            setRequestItems(row.items.map((item) => ({
                item: item.item.id,
                quantity: item.quantity
            })));
        }
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Purchase Request?",
            icon: "warning",
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(baseUrl+`delete-purchase-request-item/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted",
                            "Purchase Request Deleted",
                            "success");
                        getPurchaseRequests();
                    });
            }
        });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const headerData = new FormData();
            headerData.append("request_no", formData.request_no);
            headerData.append("requested_by", formData.requested_by);
            headerData.append("request_date", formData.request_date);
            headerData.append("purpose", formData.purpose);
            headerData.append("status", formData.status);
            headerData.append("addedby", userName);
            headerData.append("ip_add", ipAddress);
            let requestId = editId;
            if (editId === null) {
                const res = await axios.post(baseUrl + "purchase-request/", headerData);
                requestId = res.data.id;
            } else {
                await axios.put(baseUrl + `update-purchase-request/${editId}/`, headerData);

            }
            for (const item of requestItems) {
                const itemData = new FormData();
                itemData.append("request", requestId);
                itemData.append("item", item.item);
                itemData.append("quantity", item.quantity);
                await axios.post(baseUrl + "purchase-request-item/", itemData);
                
            }
            Swal.fire("Success", editId === null ? "Purchase Request Saved" : "Purchase Request Updated", "success");
            clearForm();
            getPurchaseRequests();
        } catch (err) {
            Swal.fire("Error", "Unable to Save Purchase Request", "error");
        }
        setLoading(false);
    };
    const columns = [
        {
            field: "request_no", headerName: "Request No", width: 170
        },
        {
            field: "requested_by_name",
            headerName: "Requested By",
            width: 220,
            renderCell: (params) => ( params.row.requested_by?.username )
        },
        {
            field: "request_date", headerName: "Date", width: 130
        },
        {
            field: "status", headerName: "Status", width: 130
        },
        {
            field: "purpose", headerName: "Purpose", width: 320
        },
        {
            field: "action",
            headerName: "Action",
            width: 280,
            sortable: false,
            renderCell: (params) => (
                <>

                    <button
                        className="btn btn-success btn-sm me-2"
                        onClick={() => editData(params.row)}
                    >
                        Edit
                    </button>

                    <button
                        className="btn btn-danger btn-sm me-2"
                        onClick={() => deleteData(params.row.id)}
                    >
                        Delete
                    </button>
                    <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                    window.open(
                        `/purchase-request-print/${params.row.id}`,
                        "_blank"
                    )
                }
            >
                Print
            </button>
                </>
            )
        }
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">

                        Purchase Request

                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label>Request No</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="request_no"
                                    value={formData.request_no}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Requested By</label>

                                <select
                                    className="form-control"
                                    name="requested_by"
                                    value={formData.requested_by}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select User
                                    </option>

                                    {userData.map((user) => (
                                        <option
                                            key={user.id}
                                            value={user.id}
                                        >
                                            {user.name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Request Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="request_date"
                                    value={formData.request_date}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Status</label>

                                <select
                                    className="form-control"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >

                                    <option value="PENDING">
                                        Pending
                                    </option>

                                    <option value="APPROVED">
                                        Approved
                                    </option>

                                    <option value="REJECTED">
                                        Rejected
                                    </option>

                                    <option value="CLOSED">
                                        Closed
                                    </option>

                                </select>

                            </div>

                            <div className="col-md-12 mb-3">

                                <label>Purpose</label>

                                <textarea
                                    rows="3"
                                    className="form-control"
                                    name="purpose"
                                    value={formData.purpose}
                                    onChange={handleChange}
                                />

                            </div>
                            <hr className="mt-3 mb-3"/>

                            <div className="col-md-12">

                                <div className="d-flex justify-content-between align-items-center mb-3">

                                    <h5 className="mb-0">
                                        Request Items
                                    </h5>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={addRow}
                                    >
                                        + Add Item
                                    </button>

                                </div>

                                <div className="table-responsive">

                                    <table className="table-erp-modern">

                                        <thead className="table-success">

                                        <tr>

                                            <th width="60%">Inventory Item</th>

                                            <th width="20%">Quantity</th>

                                            <th width="20%">Action</th>

                                        </tr>

                                        </thead>

                                        <tbody>

                                        {requestItems.map((row, index) => (
                                            <tr key={index}>

                                                <td>

                                                    <select
                                                        className="form-control"
                                                        name="item"
                                                        value={row.item}
                                                        onChange={(e) => handleItemChange(index, e)}
                                                        required
                                                    >

                                                        <option value="">
                                                            Select Item
                                                        </option>

                                                        {inventoryItems.map((item) => (
                                                            <option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.item_name} - {item.owner.name}
                                                            </option>
                                                        ))}

                                                    </select>

                                                </td>

                                                <td>

                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        className="form-control"
                                                        name="quantity"
                                                        value={row.quantity}
                                                        onChange={(e) => handleItemChange(index, e)}
                                                        required
                                                    />

                                                </td>

                                                <td className="text-center">

                                                    {requestItems.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeRow(index)}
                                                        >
                                                            Remove
                                                        </button>
                                                    )}

                                                </td>

                                            </tr>
                                        ))}

                                        </tbody>

                                    </table>

                                </div>

                            </div>

                            <div className="col-md-12 mt-3">

                                <button
                                    type="submit"
                                    className="btn btn-success me-2"
                                    disabled={loading}
                                >
                                    {editId === null ? "Save Purchase Request" : "Update Purchase Request"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={clearForm}
                                >
                                    Clear
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>
            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Purchase Request List
                    </h5>

                </div>

                <div className="card-body">

                    <div
                        style={{
                            height: 600, width: "100%"
                        }}
                    >

                        <ERPDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}

                            disableRowSelectionOnClick
                        />

                    </div>

                </div>

            </div>

        </div>
    );
}
export default PurchaseRequest;